import React, { useEffect } from 'react';
import { Button, Table, Tag } from 'antd';
import { Link, withRouter } from 'react-router-dom';
import { withAppContext } from 'context/AppContext';
import { buildEInvoicePlanCreateUri, buildEInvoicePlanDetailUri } from 'utils/routes';
import { useGetPaginatedProducts, formatEInvoiceQuota, formatPlanPrice } from 'utils/apis/eInvoicePlan';
import { constructColumn, constructColumnFilterSearch, constructColumnFilterRadio, handleOnAggregationTableChange } from 'utils/table/table';
import { StyledCard } from './eInvoice.styles';

const STATUS_FILTER_OPTIONS = [{ label: 'Active', value: 'active' }, { label: 'Inactive', value: 'inactive' }];

const formatStatus = record => {
  if (record.active === false) {
    return <Tag color="red">Inactive</Tag>;
  }
  return <Tag color="green">Active</Tag>;
};

const constructColumns = ({ filters = {}, sorter = {} }) => [
  {
    ...constructColumn('Name', 'name', { hasSorter: true, sorter }),
    ...constructColumnFilterSearch('name', 'Search Name', filters),
    render: (text, record) => <Link to={buildEInvoicePlanDetailUri(String(record._id))}>{text || '—'}</Link>
  },
  {
    title: 'Monthly Price',
    key: 'pricePerMonth',
    render: (_, record) => formatPlanPrice(record.pricePerMonth, record.currency)
  },
  {
    title: 'Annual Price',
    key: 'pricePerYear',
    render: (_, record) => formatPlanPrice(record.pricePerYear, record.currency)
  },
  {
    title: 'e-Invoice Quota',
    key: 'eInvoiceCount',
    render: (_, record) => formatEInvoiceQuota(record.eInvoiceCount)
  },
  {
    title: 'Status',
    key: 'status',
    ...constructColumnFilterRadio('status', STATUS_FILTER_OPTIONS),
    onFilter: () => true,
    render: (_, record) => formatStatus(record)
  }
];

const Plan = props => {
  const { user, history } = props;
  const [query, setQuery] = React.useState({ currentPage: 1, limit: 10, filter: {}, sorter: {} });
  const [tableQuery, setTableQuery] = React.useState({ filters: {}, sorter: {} });
  const { isLoading, paginatedData: planList, total } = useGetPaginatedProducts(query, {
    shouldFetch: Boolean(user && user.isAdmin)
  });

  useEffect(() => {
    if (user && !user.isAdmin) {
      history.push('/forbidden');
    }
  }, [user, history]);

  if (!user || !user.isAdmin) {
    return null;
  }

  return (
    <StyledCard
      title="Plans"
      extra={
        <Link to={buildEInvoicePlanCreateUri()}>
          <Button type="primary" icon="plus">
            Create Plan
          </Button>
        </Link>
      }
    >
      <Table
        loading={isLoading}
        rowKey={record => String(record._id)}
        columns={constructColumns({ filters: tableQuery.filters || {}, sorter: tableQuery.sorter || {} })}
        dataSource={planList}
        onChange={(pagination, filters, sorter) => {
          setTableQuery({ filters, sorter });
          handleOnAggregationTableChange({ pagination, filters, sorter }, setQuery);
        }}
        scroll={{ x: true }}
        pagination={{
          total,
          current: query.currentPage,
          pageSize: query.limit,
          showSizeChanger: true
        }}
      />
    </StyledCard>
  );
};

export default withAppContext(withRouter(Plan));
